import e from "../components/toast-content/toast-content.vue.js";
class n {
  /**
   * Creates the component for the content of a Toast Notification.
   *
   * @param options The options for creating this component.
   *
   * @returns defineComponent, Toast Content component to be passes into the ToastService functions.
   */
  static createComponent(t) {
    return {
      component: e,
      props: {
        title: t.title,
        message: t.message,
        buttonText: t.buttonText
      },
      listeners: {
        "toast-action-clicked": () => {
          t.actionButtonCallback?.();
        }
      }
    };
  }
}
export {
  n as ToastContentCreator
};
//# sourceMappingURL=toast-content-creator.js.map
